import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Question from "@/components/ques/Question";
import ExamIndexBread from "./components/ExamIndexBread.vue";
export default {
  name: "ExamWrongDo",
  components: {
    Question: Question,
    ExamIndexBread: ExamIndexBread
  },
  data: function data() {
    return {
      index: 1,
      answerImg: {},
      answer: {},
      visible: false,
      answerState: {},
      current: {},
      total: 0,
      type: this.$route.query.type,
      point_id: this.$route.query.point_id,
      practise_id: this.$route.query.practise_id,
      exam_id: this.$route.query.exam_id,
      topics: [],
      autoRemove: false,
      autoRemoveSet: new Set(),
      // 已经被自动移除的题目ID集合
      showRmoveBtn: this.$route.query.from != "collect",
      // 收藏试题不显示移除按钮
      showJudgeBtn: true,
      showAnalysis: false,
      from: this.$route.query.from,
      errorCard: {},
      section: {}
    };
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getTopicCard();

            case 2:
              _context.next = 4;
              return this.getTopic();

            case 4:
              _context.next = 6;
              return this.getAutoRemove();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    addImg: function addImg(ques, path) {
      var images = this.answerImg[ques.question_id] || [];
      images.push(path);
      this.$set(this.answerImg, ques.question_id, images);
    },
    deleteImg: function deleteImg(ques, index) {
      this.answerImg[ques.question_id].splice(index, 1);
    },
    getTopicCard: function () {
      var _getTopicCard = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var data, params, topics;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.from == "collect")) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return this.$http.get("/api/app/collect/quesCard", {
                  type: this.$route.query.collectType,
                  type_id: this.$route.query.collectTypeID
                });

              case 3:
                data = _context2.sent;
                _context2.next = 11;
                break;

              case 6:
                params = {
                  type: this.type
                };

                if (params.type == 1) {
                  params.point_id = this.point_id;
                } else if (params.type == 2) {
                  params.exam_id = this.exam_id;
                } else if (params.type == 3) {
                  params.practise_id = this.practise_id;
                }

                _context2.next = 10;
                return this.$http.post("/api/app/myExam/errorCard", params);

              case 10:
                data = _context2.sent;

              case 11:
                if (this.type == 2) {
                  topics = [];
                  data.data.forEach(function (sec) {
                    sec.child.forEach(function (ques, index) {
                      if (index == 0) {
                        _this.$set(_this.section, ques.sort, {
                          name: sec.name,
                          introduce: sec.introduce
                        });
                      }

                      topics.push(ques);

                      _this.$set(_this.answerState, ques.sort, ques.status);
                    });
                  });
                  this.topics = topics;
                  this.total = topics.length;
                } else {
                  data.data.forEach(function (t, index) {
                    t.readonly = false;

                    _this.$set(_this.answerState, index + 1, t.status);
                  });
                  this.topics = data.data;
                  this.total = data.data.length;
                }

                this.errorCard = data;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getTopicCard() {
        return _getTopicCard.apply(this, arguments);
      }

      return getTopicCard;
    }(),
    getTopic: function () {
      var _getTopic = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var data, ques, user_answer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.index > this.topics.length)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.next = 4;
                return this.$http.post("/api/app/myExam/quesDetail", {
                  ques_id: this.topics[this.index - 1].question_id
                });

              case 4:
                data = _context3.sent;
                ques = data;

                if (ques.ques_type != 5 && ques.ques_type != 7 && typeof ques.ques_option === "string") {
                  ques.ques_option = JSON.parse(ques.ques_option);
                }

                ques.index = this.index;

                if (!this.answer[ques.question_id]) {
                  if (ques.ques_type == 1 || ques.ques_type == 2) {
                    this.$set(this.answer, ques.question_id, "");
                  } else if (ques.ques_type == 3 || ques.ques_type == 4) {
                    this.$set(this.answer, ques.question_id, []);
                  } else if (ques.ques_type == 7) {
                    this.$set(this.answer, ques.question_id, ques.right_answer.map(function () {
                      return "";
                    }));
                  } else if (ques.ques_type == 5) {
                    //简答题
                    if (ques.user_answer) {
                      user_answer = JSON.parse(ques.user_answer);
                      this.$set(this.answer, ques.question_id, user_answer.content);
                      this.$set(this.answerImg, ques.question_id, user_answer.images);
                    }
                  }
                }

                this.checkDone();
                this.current = ques; //点击已做过的题目，显示我的答案为未作答，因此需要走这个方法，把我的答案放到current的user_answer里

                this.checkAnswer();

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getTopic() {
        return _getTopic.apply(this, arguments);
      }

      return getTopic;
    }(),
    getAutoRemove: function () {
      var _getAutoRemove = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$http.get("/api/app/myExam/rightRemove");

              case 2:
                data = _context4.sent;
                this.autoRemove = data.auto_remove_qb_wrong == 2;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAutoRemove() {
        return _getAutoRemove.apply(this, arguments);
      }

      return getAutoRemove;
    }(),
    answerStatus: function answerStatus(ques, rightIds) {
      var userAnswers = this.answer[ques.question_id];
      this.current.user_answer = userAnswers.join(",");

      if (userAnswers.length > 0) {
        if (userAnswers.length == rightIds.length) {
          for (var i = 0; i < rightIds.length; i++) {
            if (!userAnswers.includes(rightIds[i])) {
              return 2;
            }
          }

          return 1;
        } else {
          return 2;
        }
      } else {
        return 3;
      }
    },
    answerUserAnswerStatus: function answerUserAnswerStatus(userAnswers, right_answer) {
      if (userAnswers.length == right_answer.length) {
        for (var i = 0; i < right_answer.length; i++) {
          if (!(_typeof(right_answer) == "object" && right_answer[i].includes(userAnswers[i])) || !(typeof right_answer == "string" && userAnswers[i] == right_answer[i])) {
            return 2;
          }
        }

        return 1;
      } else {
        return 2;
      }
    },
    checkAnswer: function checkAnswer() {
      // 3未答、2答错、1正确,4,简答题已答
      var ques = this.current;
      var right_answer = "";
      var rightIds = [];

      if (ques.ques_type != 7 && ques.ques_type != 5) {
        right_answer = JSON.parse(ques.right_answer);
        right_answer.forEach(function (r) {
          rightIds.push(r.id);
        });
      } else {
        right_answer = ques.right_answer;
      }

      if (ques.ques_type == 1 || ques.ques_type == 2) {
        this.current.user_answer = this.answer[ques.question_id].toString();

        if (this.answer[ques.question_id]) {
          return rightIds.includes(this.answer[ques.question_id]) ? 1 : 2; // if (rightIds.includes(this.answer[ques.question_id])) {
          //   return 1;
          // } else {
          //   return 2;
          // }
        } else {
          return 3;
        }
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        // let userAnswers = this.answer[ques.question_id];
        // this.current.user_answer = userAnswers.join(",");
        // if (userAnswers.length > 0) {
        //   if (userAnswers.length == rightIds.length) {
        //     for (let i = 0; i < rightIds.length; i++) {
        //       if (!userAnswers.includes(rightIds[i])) {
        //         return 2;
        //       }
        //     }
        //     return 1;
        //   } else {
        //     return 2;
        //   }
        // } else {
        //   return 3;
        // }
        return this.answerStatus(ques, rightIds);
      } else if (ques.ques_type == 7) {
        var userAnswers = this.answer[ques.question_id];
        this.current.user_answer = userAnswers;

        if (userAnswers.length > 0) {
          return this.answerUserAnswerStatus(userAnswers, right_answer); // if (userAnswers.length == right_answer.length) {
          //   for (let i = 0; i < right_answer.length; i++) {
          //     if (
          //       !(
          //         typeof right_answer == "object" &&
          //         right_answer[i].includes(userAnswers[i])
          //       ) ||
          //       !(
          //         typeof right_answer == "string" &&
          //         userAnswers[i] == right_answer[i]
          //       )
          //     ) {
          //       return 2;
          //     }
          //   }
          //   return 1;
          // } else {
          //   return 2;
          // }
        } else {
          return 3;
        }
      } else if (ques.ques_type == 5) {
        var _userAnswers = "";
        _userAnswers = JSON.stringify({
          content: this.answer[ques.question_id],
          images: this.answerImg[ques.question_id] || []
        });
        this.current.user_answer = _userAnswers; //简答题
        // if (
        //   this.answer[ques.question_id] ||
        //   (this.answerImg[ques.question_id] || []).length > 0
        // ) {
        //   return 4;
        // } else {
        //   return 3;
        // }

        return this.answer[ques.question_id] || (this.answerImg[ques.question_id] || []).length > 0 ? 4 : 3;
      }
    },
    // forceDone 强行完成
    checkDone: function checkDone() {
      var forceDone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (forceDone || this.answerState[this.index] != 3) {
        this.showAnalysis = true;
        this.showJudgeBtn = false;
      } else {
        this.showAnalysis = false;
        this.showJudgeBtn = true;
      }
    },
    onChange: function onChange() {
      if (this.current.ques_type == 1 || this.current.ques_type == 2) {
        this.onJudge();
      }
    },
    onJudge: function () {
      var _onJudge = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        var res, status;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.from == "mistake")) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 3;
                return this.$http.post("/api/app/question/error/setErrorCount");

              case 3:
                res = _context5.sent;

                if (!(res.code == 203)) {
                  _context5.next = 7;
                  break;
                }

                this.visible = true;
                return _context5.abrupt("return");

              case 7:
                status = this.checkAnswer();

                if (status != 3) {
                  this.topics.find(function (t) {
                    return t.question_id == _this2.current.question_id;
                  }).readonly = true;
                }

                this.$set(this.answerState, this.index, status);

                if (this.current.ques_type == 1 || this.current.ques_type == 2) {
                  this.checkDone();
                } else if (this.current.ques_type == 3 || this.current.ques_type == 4) {
                  this.checkDone(true);
                } else if (this.current.ques_type == 7) {
                  this.checkDone(true);
                } else if (this.current.ques_type == 5) {
                  this.checkDone(true);
                } // 处理自动定移除错题


                if (this.autoRemove && status == 1 && !this.autoRemoveSet.has(this.current.question_id)) {
                  this.autoRemoveSet.add(this.current.question_id);
                  this.$http.post("/api/app/myExam/quesRemove", {
                    ques_id: this.current.question_id
                  });
                }

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onJudge() {
        return _onJudge.apply(this, arguments);
      }

      return onJudge;
    }(),
    navPrev: function () {
      var _navPrev = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(this.index == 1)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                this.index--;
                _context6.next = 5;
                return this.getTopic();

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function navPrev() {
        return _navPrev.apply(this, arguments);
      }

      return navPrev;
    }(),
    navNext: function () {
      var _navNext = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.index == this.total)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                this.index++;
                _context7.next = 5;
                return this.getTopic();

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function navNext() {
        return _navNext.apply(this, arguments);
      }

      return navNext;
    }(),
    goTo: function () {
      var _goTo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(index) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.index = index;
                _context8.next = 3;
                return this.getTopic();

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function goTo(_x) {
        return _goTo.apply(this, arguments);
      }

      return goTo;
    }(),
    onBack: function () {
      var _onBack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var count, key, tip;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                count = 0;

                for (key in this.answerState) {
                  if (this.answerState[key] == 3) {
                    count++;
                  }
                }

                tip = "";

                if (this.from == "mistake") {
                  tip = "是否结束巩固？";

                  if (count > 0) {
                    tip = "还有题目未做完，是否结束巩固？";
                  }
                } else if (this.from == "collect") {
                  tip = "是否结束练习？";

                  if (count > 0) {
                    tip = "还有题目未做完，是否结束练习？";
                  }
                }

                _context9.next = 6;
                return this.$promiseConfirm(tip);

              case 6:
                this.$router.push({
                  name: "MemberEvaluation",
                  query: {
                    tab: this.from
                  }
                });

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function onBack() {
        return _onBack.apply(this, arguments);
      }

      return onBack;
    }()
  }
};